// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xy-z","tooltipWrapper":"yy-z","icon":"zy-z","tooltip":"Ay-z","content":"By-z"};